import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';

class PageDesign extends Component {

  render() {
    return (
      <Page primaryTitle="Design" secondaryTitle="" section="">
          <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 pageDesign">
              <p className="intro">The design of your product, whether it is company branding, an exhibit, print collateral, or an accessory, is like a fingerprint - it should be unique to your company. It should reflect your style and and send a clear message about who you are. SLA Service Management has designers that are eager to channel their creative juices into a product that will wow you and your customers!</p>

              <h3>Design Services</h3>
              <ul>
                  <li>Exhibits and exhibit graphics</li>
                  <li>Exhibit accessories (table throws, banners, tents, floor mats, counters and more!)</li>
                  <li>Event marketing materials (invitations, room drops, prize signs and more!</li>
                  <li>Company branding</li>
              </ul>

          </div>
          <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
              <SideImage page={this.props.page} />
          </aside>
      </Page>
    );
  }
}

export default PageDesign;



// WEBPACK FOOTER //
// ./src/pages/PageDesign/PageDesign.js